module.exports = __webpack_public_path__ + "b6d59f3b6f6a9a3c72465872294820d1.svg";